import styled from "styled-components";

export const Button = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 16px;
    border: none;
    outline: none;
    vertical-align: top;
    font-weight: 400;
    font-size: 12px;
    background: transparent;
    cursor: pointer;
    transition: 300ms;
    &:hover {
        transform: scale(1.2);
    }

    span {
        background-color: ${p => p.theme.c.info};
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 8px;
        color: ${p => p.theme.c.whiteOnActive};
        margin: auto;
    }
`;

export const Wrapper = styled.div`
    display: inline-block;
`;
